export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_1.7af9399f.png";